import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import type { IconProp } from "@fortawesome/fontawesome-svg-core";

interface PageTitleProps {
    title: string;
    icon?: IconProp | null;
    color?: string; // Any CSS color: "black", "#333", "rgb(...)"
}

const PageTitle = ({ title, icon = null, color = "black" }: PageTitleProps) => {
    return (
        <div className="flex items-center flex-1 mb-10">
            {icon && (
                // me-3 puts the gap on the side facing the title, in both directions
                <FontAwesomeIcon icon={icon} color={color} size="2x" className="me-3" />
            )}

            <h1 className="text-3xl" style={{ color }}>
                {title}
            </h1>
        </div>
    );
};

export default PageTitle;